// src/components/ClientBackground.js
import React from "react";

export default function ClientBackground() {
  return (
    <div className="pointer-events-none fixed inset-0 h-screen w-screen overflow-hidden" style={{ zIndex: 0 }}>
      <svg
        viewBox="0 0 390 844"
        preserveAspectRatio="none"
        className="absolute top-0 left-0 h-full w-full"
        aria-hidden="true"
      >
        <rect width="390" height="844" fill="#FFFFFF" />
        
        <path
          d="M 0 0 
             L 390 0 
             L 390 80
             C 360 85, 340 110, 320 120
             C 300 130, 280 110, 260 110
             C 240 130, 220 140, 200 170
             C 180 200, 160 185, 140 165
             C 120 155, 100 85, 80 95
             C 60 105, 40 145, 20 160
             C 10 165, 5 165, 0 160
             Z"
          fill="#FDE9EB"
        />

        {/* TOP GOLDEN CURVE */}
        <path
          d="
            M 0 0
            C 10 -10, 20 -10, 30 -5
            C 50 10, 70 10, 90 10
            C 110 10, 130 10, 150 -10
            C 170 -10, 190 20, 210 50
            C 230 80, 250 100, 270 125
            C 290 140, 310 150, 330 155
            C 350 155, 370 155, 390 155
          "
          fill="none"
          stroke="#FFDE70"
          strokeWidth="4"
          strokeLinecap="round"
        />

      </svg>
    </div>
  );
}